const MONTHS = {
  Januari:0, Februari:1, Maret:2, April:3, Mei:4, Juni:5,
  Juli:6, Agustus:7, September:8, Oktober:9, November:10, Desember:11,
  Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5,
  Jul:6, Aug:7, Agu:7, Sep:8, Oct:9, Okt:9, Nov:10, Dec:11, Des:11,
};

function parseExpDate(str) {
  if (!str) return new Date(0);
  const t = String(str).trim();
  if (/present|sekarang|now/i.test(t)) return new Date(9999, 11, 31);
  if (/^\d{4}$/.test(t)) return new Date(+t, 0, 1);
  // "Maret 2025" or "Mar 2025" or "2025-03"
  if (/^\d{4}-\d{2}/.test(t)) {
    const [y, m] = t.split("-");
    return new Date(+y, +m - 1, 1);
  }
  const [mon, yr] = t.split(/[\s-]+/);
  return new Date(+yr || 0, MONTHS[mon] ?? 0, 1);
}

// Priority: lower number = higher priority (goes to top)
const EMP_PRIORITY = {
  "full-time": 0,
  "contract": 1,
  "self-employed": 2,
  "part-time": 3,
  "internship": 4,
  "apprenticeship": 5,
  "freelance": 6,
  "seasonal": 7,
  "bootcamp student": 8,
};

function empPriority(type) {
  return EMP_PRIORITY[(type || "").toLowerCase()] ?? 99;
}

function effectiveEnd(exp) {
  if (exp.is_current || !exp.end_date) return new Date(9999, 11, 31);
  return parseExpDate(exp.end_date);
}

export function sortExperience(items) {
  return [...items].sort((a, b) => {
    const endA = effectiveEnd(a).getTime();
    const endB = effectiveEnd(b).getTime();
    if (endB !== endA) return endB - endA;                        // terbaru dulu

    const startA = parseExpDate(a.start_date || a.start).getTime();
    const startB = parseExpDate(b.start_date || b.start).getTime();
    if (startB !== startA) return startB - startA;               // mulai lebih baru dulu

    return empPriority(a.employment_type) - empPriority(b.employment_type); // tiebreaker
  });
}

// Returns human-readable duration string, e.g. "3 mo", "1 yr 2 mo"
export function calcDuration(startStr, endStr, isCurrent) {
  const start = parseExpDate(startStr);
  if (!startStr || start.getTime() === 0) return null;
  const end = isCurrent || !endStr ? new Date() : parseExpDate(endStr);
  // +1 to make the range inclusive (Feb–Apr = 3 months, not 2), but only if end month > start month
  let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  if (end.getMonth() > start.getMonth()) months += 1;
  if (months < 1) months = 1;
  const y = Math.floor(months / 12);
  const m = months % 12;
  if (y === 0) return `${m} mo`;
  if (m === 0) return `${y} yr`;
  return `${y} yr ${m} mo`;
}

// For grouped (by company): sort companies by their most-recent entry
export function sortExperienceGrouped(items) {
  const grouped = items.reduce((acc, item) => {
    const co = item.company || "Unknown";
    if (!acc[co]) acc[co] = [];
    acc[co].push(item);
    return acc;
  }, {});

  return Object.entries(grouped)
    .map(([company, roles]) => [company, sortExperience(roles)])
    .sort(([, a], [, b]) => {
      const latestA = Math.max(...a.map((r) => effectiveEnd(r).getTime()));
      const latestB = Math.max(...b.map((r) => effectiveEnd(r).getTime()));
      if (latestB !== latestA) return latestB - latestA;

      const startA = Math.max(...a.map((r) => parseExpDate(r.start_date || r.start).getTime()));
      const startB = Math.max(...b.map((r) => parseExpDate(r.start_date || b.start).getTime()));
      return startB - startA;
    });
}
